import _extends from 'babel-runtime/helpers/extends';

import VideoPlayer from './videoPlayer.vue';
import FileMeta from './file-meta.vue';

export default {
  components: {
    VideoPlayer: VideoPlayer,
    FileMeta: FileMeta
  },

  props: {
    url: {
      type: String,
      required: true
    },
    cover: {
      type: String
    },
    fileMeta: {
      type: Object
    },
    videoStyle: {
      type: Object
    },
    fileMetaStyle: {
      type: Object
    }
  },

  computed: {
    innerVideoStyle: function innerVideoStyle() {
      return _extends({
        maxWidth: '120px',
        maxHeight: '120px'
      }, this.videoStyle);
    }
  }
};